import { mixins, typography } from '../core/utils';

import styled from '@emotion/styled';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';

export const Text = styled.span<{
   variant?: 'body-s' | 'body-m' | 'body-l';
   color?: keyof typeof theme.colors.text | keyof typeof theme.colors.state;
   weight?: keyof typeof tokens.font.weight;
}>`
   ${({ variant = 'body-m' }) => typography[variant === 'body-s' ? 'bodyS' : variant === 'body-l' ? 'bodyL' : 'bodyM']};
   color: ${({ color = 'primary' }) => {
      if (color in theme.colors.text) return theme.colors.text[color as keyof typeof theme.colors.text];
      if (color in theme.colors.state) return theme.colors.state[color as keyof typeof theme.colors.state];
      return theme.colors.text.primary;
   }};
   ${({ weight }) => weight && `font-weight: ${tokens.font.weight[weight]};`}
`;

export const Heading = styled.h1<{ level?: 'xl' | 'l' | 'm' | 's' | 'xs' }>`
   ${({ level = 'l' }) => {
      const map = {
         xl: typography.headingXL,
         l: typography.headingL,
         m: typography.headingM,
         s: typography.headingS,
         xs: typography.headingXS,
      };
      return map[level];
   }};
   color: ${theme.colors.text.primary};
   margin: 0;
`;

export const Label = styled.label`
   ${typography.bodyM};
   font-weight: ${tokens.font.weight.medium};
   color: ${theme.colors.text.secondary};
`;

export const Caption = styled.span`
   ${typography.bodyS};
   color: ${theme.colors.text.tertiary};
`;

export const Card = styled.div`
   ${mixins.card};
   padding: ${tokens.space.lg};
`;

export const SectionLabel = styled.div`
   ${typography.bodyS}
   text-transform: uppercase;
   letter-spacing: 0.5px;
   margin-bottom: ${tokens.space.sm};
   color: ${theme.colors.text.secondary};
   font-weight: ${tokens.font.weight.semibold};
`;

export const SectionDescription = styled(Text)`
   display: block;
   margin-bottom: ${tokens.space.md};
`;

export const HintText = styled(Text)`
   margin-top: ${tokens.space.xs};
   font-style: italic;
`;

export const TruncatedText = styled.span`
   ${mixins.truncate}
   display: inline-block;
   max-width: 200px;
   vertical-align: bottom;
`;

export const InfoRow = styled.div`
   display: flex;
   flex-direction: column;
   gap: ${tokens.space.xs};
`;

export const InfoLabel = styled.span`
   ${typography.bodyS}
   color: ${theme.colors.text.secondary};
`;

export const InfoValue = styled.span`
   ${typography.bodyM}
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.primary};
`;

export const EmptyState = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: ${tokens.space.xxl};
   color: ${theme.colors.text.disabled};
   text-align: center;
`;

export const EmptyStateText = styled.p`
   ${typography.bodyM}
   margin: 0;
`;

export const FooterSpacer = styled.div`
   flex: 1;
`;

export const Box = styled.div<{
   p?: keyof typeof tokens.space;
   m?: keyof typeof tokens.space;
   gap?: keyof typeof tokens.space;
}>`
   ${({ p }) => p && `padding: ${tokens.space[p]};`}
   ${({ m }) => m && `margin: ${tokens.space[m]};`}
   ${({ gap }) => gap && `gap: ${tokens.space[gap]};`}
`;
